import { IOSMResponse } from '@eventr/common'
import { ColoursObj } from '@eventr/common-storybook'
import { useMemo } from 'react'
import { openMobileMapsLink } from '../../../utils'
import { CardText } from './cardText'
import { ColouredIcon } from './colouredIcon'
import { RowInfo } from './rowInfo'

interface IRowInfoAddressProps {
    address: IOSMResponse
}
export const RowInfoAddress = ({ address }: IRowInfoAddressProps) => {
    const addressString = useMemo(() => {
        if (!address) return ''
        const addressStringArray = [
            address.address?.house_number,
            address.address?.road,
            address.address?.city,
            address.address?.country,
            address.address?.postcode,
        ]

        return addressStringArray
            .filter((item) => item !== undefined && item !== '')
            .join(', ')
    }, [address])

    const onClick = () => {
        try {
            openMobileMapsLink(addressString.replaceAll(' ', '+'))
        } catch (error) {
            console.error('Error opening maps link:', error)
        }
    }
    if (addressString === '') return null
    return (
        <RowInfo
            start={
                <ColouredIcon
                    name={'Location_Pin'}
                    bubble
                    bubbleColour={ColoursObj.coreBrights.secondary}
                />
            }
            middle={<CardText onClick={onClick}>{addressString}</CardText>}
        />
    )
}
